import { render, staticRenderFns } from "./inquiryMaster.vue?vue&type=template&id=366c2670&scoped=true&"
import script from "./inquiryMaster.vue?vue&type=script&lang=js&"
export * from "./inquiryMaster.vue?vue&type=script&lang=js&"
import style0 from "./inquiryMaster.vue?vue&type=style&index=0&id=366c2670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366c2670",
  null
  
)

export default component.exports